import styled from 'styled-components';

export const EmptyResults = styled.div`
  .empty-results,
  &.empty-results {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;

    &__reset {
      font-size: 18px;
      margin-bottom: 12px;
    }

    button {
      width: 100%;
      max-width: 185px;
    }
  }
`;

export default EmptyResults;
